<template>
  <div class="form-row">
    <div class="form-group col-12">
      <p class="font-weight-bold">Select Image</p>
      <div class="models-wrapper">
        <div v-for="(model, key) in mediaImages"
             :key="key"
             class="model-item"
             @click="changeSelectedModel(key, model)"
             :class="{'active': activeModel === model.name }"
        >
          <template v-if="model.hasOwnProperty('image')">
            <img :src="model.image.imageURL" class="img-fluid"/>
          </template>
          <p>{{ model.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapActions, mapState } from 'vuex'
import { uuid } from 'vue-uuid'

export default {
  components: {},
  data () {
    return {
      activeModel: 'Select Image',
      positionOfOrigin: [0, 0, 0],
      rotationOfOrigin: [0, 0, 0],
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
    }
  },
  created () {
    this.listMediaImages()
  },

  methods: {
    ...mapActions([
      'listMediaImages'
    ]),
    changeSelectedModel (index, model) {
      this.activeModel = model.name
      this.characters.map((char) => ({ ...char, active: false }))
      let id = uuid.v1()
      let selectedOne = {
        objectId: id,
        type: "Image",
        objectName: model.name,
        objectDbHash: index,
        displayType: model.typeOfDisplay || 'Screen',
        objectDescription: model.description || '',
        objectUrl: model.image.imageURL,
        startTime: 0,
        endTime: model.duration || 2,
        duration: model.duration || 2,
        layer: model.layer || 0,
        objectSizeDelta: {
          width: model.mediaWidth || 200,
          height: model.mediaHeight || 200
        },
        scale: 0.5,
        simpleTransform: true,
        objectTransformSimple: {
            horizontal: model.horizontalAlignment || 'center',
            vertical: model.verticalAlignment || 'center',
            offsetHorizontal: model.offsetHorizontal || 0,
            offsetVertical: model.offsetVertical || 0,
        },
        positionOfOrigin: model.hasOwnProperty('positionOfOrigin') 
          ? [ model.positionOfOrigin['X'], model.positionOfOrigin['Y'], model.positionOfOrigin['Z'] ]
          : this.positionOfOrigin,
        rotationOfOrigin: model.hasOwnProperty('rotationOfOrigin') 
          ? [ model.rotationOfOrigin['X'], model.rotationOfOrigin['Y'], model.rotationOfOrigin['Z'] ] 
          : this.rotationOfOrigin,
        active: true,
      }
      this.$store.dispatch('updateCharacters', [
        ...this.characters.map((char) => ({ ...char, active: false})),
        selectedOne
      ])
      this.$emit('triggerSelectedModel', { index, model })
      this.$emit('closePopup')
    }
  },
  mounted () {},
  watch: {},
  computed: {
    ...mapState([
      'mediaImages',
      'characters'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/timeline-components/mediaImages.vue